import React from 'react';
import { motion } from 'framer-motion';
export function SkinResultsSection() {
  return <section className="py-20 bg-brand-cream pt-[20px] pb-[20px] relative overflow-hidden" data-id="element-197" data-mp="26ab1tde3074o">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-gold/15 rounded-full blur-[80px] -z-10 animate-pulse-glow" data-id="element-198" data-mp="228h85p2b03e0" />

      <div className="container mx-auto px-6 md:px-12 flex justify-center relative z-10" data-id="element-199" data-mp="1x79yfkglou4p">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="max-w-2xl w-full relative" data-id="element-200" data-mp="2tyuavv4ygnxt">
          <div className="absolute -inset-4 bg-gradient-to-r from-brand-beige via-brand-cream to-brand-gold opacity-40 blur-2xl rounded-[2rem] -z-10 animate-pulse-glow" data-id="element-201" data-mp="2fz2trlj56rfl" />
          <div className="rounded-2xl overflow-hidden shadow-2xl shadow-brand-gold/20 border border-white/50" data-id="element-202" data-mp="14kfrlqcpht9p">
            <img src="https://cdn.magicpatterns.com/uploads/j1no15p8UWhstkQMH6xBgJ/ChatGPT_Image_21_jul_2026,_04_59_15_p.m..png" alt="Piel más sana, luminosa y uniforme después de mi rutina RIMAN" className="w-full h-auto object-cover" data-id="element-203" data-mp="211sboe4n71wr" />
          </div>
        </motion.div>
      </div>
    </section>;
}